import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { FaTimes } from "react-icons/fa";

const ModalLayout = ({
  show,
  close,
  showCancel,
  children,
  title,
  subTitle,
  isDisabled,
  onClick,
  btnText,
  cancelText,
  setStage,
  stage,
  hideFooter,
}) => {
  return (
    <>
      <Transition.Root show={show} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-50 md:modalUp inset-0 overflow-y-auto"
          initialFocus={true}
          // onClose={() => close(true)}
          onClose={() => show}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="relative inline-block bg-white rounded-lg text-center overflow-hidden shadow-xl transform transition-all my-4 align-middle max-w-lg w-full">
                <div className="bg-white px-4 pt-4 pb-4 sm:p-4 sm:pb-4">
                  <div className="sm:px-2 sm:flex sm:flex-row absolute right-2">
                    <FaTimes
                      className="cursor-pointer text-[#5B2E4F]"
                      size={20}
                      onClick={() => close(false)}
                    />
                  </div>

                  <div className=" sm:mt-0 text-left pt-4">
                    <Dialog.Title as="h3" className="px-4 flex flex-col">
                      {/* <div className="flex items-center space-x-5">
                                                <IoChevronBackOutline size={20} className="cursor-pointer" />
                                                <p className="text-[#5B2E4F] text-[18px] font-[700px] leading-5 BoldFonter mb-2">{title}</p>
                                            </div> */}
                      <p className="text-[#5B2E4F] text-[18px] font-[700px] leading-5 BoldFonter mb-2">
                        {title}
                      </p>
                      <p className="text-[14px] font-[400px] text-[#33343D] leading-4 mb-4">
                        {subTitle}
                      </p>
                    </Dialog.Title>
                    <div className="px-4 mt-2 mb-5">{children}</div>

                    {!hideFooter && (
                      <>
                        <hr />
                        <div className="flex justify-end space-x-4">
                          {showCancel && (
                            <button
                              type="button"
                              onClick={
                                setStage ? () => setStage(stage - 1) : !show
                              }
                              disabled={isDisabled}
                              className="border border-hervestPink disabled rounded text-hervestPink w-[128px] px-10 py-2 text-[12px] font-[500px] leading-4 my-5"
                            >
                              {cancelText || "CANCEL"}
                            </button>
                          )}

                          <button
                            type="button"
                            onClick={onClick}
                            disabled={isDisabled}
                            className="bg-[#5B2E4F] font-extrabold  text-nowrap rounded text-white w-[128px] px-10 py-3 text-[12px] leading-4 my-5"
                          >
                            {btnText}
                          </button>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default ModalLayout;
